// @ts-nocheck
import { syncGauntletCursor } from "../../cursor";
import { Game } from "../game-base";

Game.prototype.syncCustomCursor = function () {
  syncGauntletCursor(this.mouse.x, this.mouse.y, this.mouse.down, this.mouse.over);
};
